export enum OneToOneMeetingStatus {
  SCHEDULED = 'SCHEDULED',
  IN_PROGRESS = 'IN_PROGRESS',
  MISSED = 'MISSED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  AUTO_COMPLETED = 'AUTO_COMPLETED',
  REOPENED = 'REOPENED'
}
